import { render, staticRenderFns } from "./LevelTwo.vue?vue&type=template&id=b1dbac0c&scoped=true&"
import script from "./LevelTwo.vue?vue&type=script&lang=js&"
export * from "./LevelTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1dbac0c",
  null
  
)

export default component.exports